import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_EXPENSE_TYPES, ADD_EXPENSE_TYPE, DELETE_EXPENSE_TYPE
} from 'redux/actionTypes';

export const getExpenseTypes = () => (dispatch, getState) => {
  axiosClient
    .get('/api/expenseTypes', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EXPENSE_TYPES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addExpenseType = (newType) => (dispatch, getState) => {
  axiosClient
    .post('/api/expenseTypes', newType, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_EXPENSE_TYPE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const deleteExpenseType = (name) => (dispatch, getState) => {
  axiosClient
    .delete('/api/expenseTypes', { params: { name }, ...tokenConfig(getState) })
    .then(res => {
      if(res.status === 204) {
        dispatch({
          type: DELETE_EXPENSE_TYPE,
          payload: { name }
        });
      }
    })
    .catch(err => console.log(err))
};